import { Link } from 'react-router-dom';
import { categories } from '../../data/categories';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-emerald-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              EquiNord
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Prissammenligning af hesteudstyr og rideudstyr fra danske forhandlere. EquiNord er et affiliate-overblik – du køber direkte i shoppen.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Kategorier</h3>
            <ul className="space-y-2">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link to={category.path} className="text-gray-300 hover:text-emerald-400">{category.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-emerald-400">Om os</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-emerald-400">FAQ</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-emerald-400">Blog</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-emerald-400">Privatlivspolitik</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="text-center">
            <div className="text-gray-400 text-sm">
              <p className="mb-2">
                <strong>Affiliate-oplysning:</strong> EquiNord deltager i affiliate-programmer.
                Vi kan tjene en kommission fra kvalificerede køb gennem vores links uden ekstra omkostning for dig.
              </p>
              <p className="mb-2">
                <a href="https://andaccessories.dk" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 hover:underline">
                  andaccessories.dk
                </a>
              </p>
              <p>&copy; {new Date().getFullYear()} EquiNord. Alle rettigheder forbeholdes.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
